export default {
  CODE_MATRIX: [
    { code: 32, alphabet: ' ' },
    { code: 65, alphabet: 'A' },
    { code: 66, alphabet: 'B' },
    { code: 67, alphabet: 'C' },
    { code: 68, alphabet: 'D' },
    { code: 69, alphabet: 'E' },
    { code: 70, alphabet: 'F' },
    { code: 71, alphabet: 'G' },
    { code: 72, alphabet: 'H' },
    { code: 73, alphabet: 'I' },
    { code: 74, alphabet: 'J' },
    { code: 75, alphabet: 'K' },
    { code: 76, alphabet: 'L' },
    { code: 77, alphabet: 'M' },
    { code: 78, alphabet: 'N' },
    { code: 79, alphabet: 'O' },
    { code: 80, alphabet: 'P' },
    { code: 81, alphabet: 'Q' },
    { code: 82, alphabet: 'R' },
    { code: 83, alphabet: 'S' },
    { code: 84, alphabet: 'T' },
    { code: 85, alphabet: 'U' },
    { code: 86, alphabet: 'V' },
    { code: 87, alphabet: 'W' },
    { code: 88, alphabet: 'X' },
    { code: 89, alphabet: 'Y' },
    { code: 90, alphabet: 'Z' },
    { code: 189, alphabet: '-' }
  ]
}



// WEBPACK FOOTER //
// ./src/common/key_code_matrix.js